export const SERVER_ = window.location.protocol+"//sarh.cloud:3403/"
// export const SERVER_ = window.location.protocol+"//"+window.location.hostname+":3403/"